import { Injectable } from '@angular/core'
import { SendTemplateDrawerComponent } from './send-template-drawer.component'
import { DialogService, User } from '@tokeet-frontend/tv3-platform'
import { ContractSignerType } from '@tokeet-frontend/signature'
import { Guest } from '@tv3/store/guest/guest.model'

@Injectable({
  providedIn: 'root',
})
export class SendTemplateDrawerService {
  constructor(private dialog: DialogService) {}

  public open(templateId: string, signer?: { type: ContractSignerType; data: Guest | User }) {
    return this.dialog.openDrawer(SendTemplateDrawerComponent, {
      panelClass: 'drawer-full-80',
      data: { templateId, signer },
    })
  }
}
